import React from "react";
import Image from "@/components/Image";

const BannerTop = () => {
  return (
    <div className="banner-part d-grid align-content-center">
      <div className="sub-banner">
        <div className="container">
          <h1>Contact</h1>
          {/* <ul className="d-flex justify-content-center list-unstyled">
            <li>Home</li>
            <li>/</li>
            <li>
              <a href="services.html"> Contact </a>
            </li>
          </ul> */}
        </div>
      </div>
      <Image name="sub-banner.jpg"/>
    </div>
  );
};

export default BannerTop;
